import React, { useEffect, useState } from 'react';

interface ClickIndicatorProps {
  x: number;
  y: number;
  color: string;
  onAnimationComplete: () => void;
}

const ClickIndicator: React.FC<ClickIndicatorProps> = ({
  x,
  y,
  color,
  onAnimationComplete,
}) => {
  const [isAnimating, setIsAnimating] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAnimating(false);
      onAnimationComplete();
    }, 600); // Animation duration

    return () => clearTimeout(timer);
  }, [onAnimationComplete]);

  if (!isAnimating) return null;

  return (
    <div
      className="click-indicator"
      style={{
        position: 'absolute',
        left: `${x * 100}%`,
        top: `${y * 100}%`,
        transform: 'translate(-50%, -50%)',
        pointerEvents: 'none',
        zIndex: 1002,
      }}
    >
      {/* Inner circle */}
      <div
        className="click-pulse"
        style={{
          width: '8px',
          height: '8px',
          backgroundColor: color,
          borderRadius: '50%',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      />

      {/* Outer ripple */}
      <div
        className="click-ripple"
        style={{
          width: '40px',
          height: '40px',
          border: `2px solid ${color}`,
          borderRadius: '50%',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      />
    </div>
  );
};

export default ClickIndicator;
